module.exports = __webpack_public_path__ + "static/media/for-sale-pana-building.e1db9e44.svg";